import * as React from "react";
import {Alert, Spinner, Button, Form, Card, Modal, Accordion, Col, Row} from "react-bootstrap";
import { connect } from "react-redux";
import {getProjects, GET_PROJECTS_REQUEST, CREATE_PROJECT_REQUEST} from "../../redux/projects/action";
import withRequestState from "../../components/WithRequestState";
import { RequestStateProps } from "../../interfaces/RequestState";
import {Link, RouteComponentProps, withRouter} from "react-router-dom";
import { State } from "../../interfaces/State";
import "./index.scss";
import { Project } from "../../interfaces/Project";
import ProjectSummary from "./projectSummary";

interface IProps {
    getProjects: () => void;
    projects: Project[];
}

interface IState {
}

class Projects extends React.Component<IProps & RouteComponentProps & RequestStateProps, IState> {

    constructor(props){
        super(props);
    }

    componentDidMount(){
        this.props.getProjects();
    }

    goTo(id:number){
        this.props.history.push(`/projects/${id}`);
    }

    render(){
        return (
            <div className="p-4">  

                <h2>Your Projects</h2>

                {
                    this.props.isPending ? 
                        <Spinner animation="border" /> : 
                        <React.Fragment>

                            {
                                this.props.projects.length == 0 ? 
                                    <Alert variant="info" className="mx-3">
                                        No sites
                                    </Alert> : 
                                    <div>
                                       {
                                            this.props.projects.map((site, index) => (
                                                <Row className="my-4" key={index}>
                                                    <Col md={8} xs={12}>
                                                        <ProjectSummary project={site} />
                                                    </Col>
                                                </Row>   
                                            ))
                                        }
                                    </div>
                                                                       
                            }
                        </React.Fragment>
                }
                
                

                <Link to="/projects/new">
                    <Button variant="outline-primary" className="mt-3 ml-3">
                        Create new site
                    </Button>
                </Link>
            </div>
        )
    }

}


export default withRouter(connect((state : State) => ({
    projects: state.projects
}), ({
    getProjects
}))(withRequestState(Projects, [GET_PROJECTS_REQUEST, CREATE_PROJECT_REQUEST])));